var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from 'react';
import styled, { css } from 'styled-components';
import { BASE_FONT_SEMI_BOLD_WEIGHT, SIZE_S, SPACING_XL } from "../../helpers";
import { useGridContext } from '../features';
import { Text, TEXT_VIEW } from "../../Text";
import { STACK_ALIGN, STACK_DIRECTION, STACK_DISTRIBUTION, StackView } from "../../StackView";
import { INDENT, VIEW_BORDER } from "../../View";
var IndicatorCount = styled.span(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    margin-left: ", ";\n    ", "\n"], ["\n    margin-left: ", ";\n    ",
    "\n"])), SIZE_S, function (props) {
    return props.isSelected && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            color: ", ";\n            font-weight: ", ";\n        "], ["\n            color: ", ";\n            font-weight: ", ";\n        "])), props.theme.colorTextMain, BASE_FONT_SEMI_BOLD_WEIGHT);
});
export var gridSelectionId = 'grid-selection-box';
function defaultSelectionSubheaderRenderer(_a) {
    var total = _a.total, selected = _a.selected;
    return (React.createElement(StackView, { direction: STACK_DIRECTION.column, align: STACK_ALIGN.fill, distribution: STACK_DISTRIBUTION.center, indentHorizontal: INDENT.s, clipped: true },
        React.createElement(Text, { view: TEXT_VIEW.secondary, truncate: true },
            "Selected:",
            React.createElement(IndicatorCount, { isSelected: !!selected.length }, selected.length), " of " + total)));
}
var GridSelection = function (_a) {
    var _b = _a.selectionSubheaderRenderer, selectionSubheaderRenderer = _b === void 0 ? defaultSelectionSubheaderRenderer : _b;
    var selection = useGridContext().state.selection;
    if (!selection) {
        return null;
    }
    var multiple = selection.multiple, selected = selection.selected, fullLength = selection.fullLength;
    if (!multiple) {
        return null;
    }
    var subheader = selectionSubheaderRenderer === null || selectionSubheaderRenderer === void 0 ? void 0 : selectionSubheaderRenderer({
        selected: selected,
        total: fullLength
    });
    if (!subheader) {
        return null;
    }
    return (React.createElement(StackView, { "data-selector-id": gridSelectionId, size: { height: SPACING_XL }, align: STACK_ALIGN.fill, distribution: STACK_DISTRIBUTION.fill, borderBottom: VIEW_BORDER.grid, clipped: true }, subheader));
};
export default GridSelection;
var templateObject_1, templateObject_2;
//# sourceMappingURL=GridSelection.js.map